import { useEffect, useState } from 'react';
import './resultcard.css';
import ResultGifs from '../../resultGifs.json';
import Timer from '../timer/timer';
import { config } from '../../config';

function ResultCard({correct, situation, onNext, gameData}) {

  const [resultGif, setResultGif] = useState();

  useEffect(() => {

  

    if(correct === situation.correct){
      const random = Math.floor(Math.random() * ResultGifs.right.length);
      setResultGif(ResultGifs.right[random]);
    }else{
      const random = Math.floor(Math.random() * ResultGifs.wrong.length);
      setResultGif(ResultGifs.wrong[random]);
    }
  }, [correct, situation.correct]);

  return (
    <>
    <Timer onDone={() => onNext()} duration={gameData.config?.answer_duration || config.answerDuration} />
    <div id='result-card' className="result-card-container" onClick={() => onNext()}>

      <img src={resultGif} className="gif" alt="" />
      <br/>
      <b>{correct === situation.correct ? "Correct" : "Incorrect"} </b>
      <br/>
      <span className='subtitle'>{situation.answer}</span>

    </div>
    </>
  );
}

export default ResultCard;
